module.exports = __webpack_public_path__ + "img/pr-8.1d47de12.png";